
<template>
    <div>
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col cols="4">
                    <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="form.semester_id"
                                                 :setActive="true"
                                                 disabled
                                                 :validate-error="errors[0]"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <b-form-group :label="$t('course')" class="mb-1">
                        <ValidationProvider name="course_id" rules="required"
                                            v-slot="{ errors }">
                            <instructor-course-auto-complete v-model="form.course_id"
                                                             :semesterId="semesterId"
                                                             :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('teaching_staff')">
                        <ValidationProvider name="instructor_id" rules="required" v-slot="{ errors }">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :valueObject="instructorValueObject"
                                                 :validate-error="errors[0]" />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="from_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('from_date')">
                            <b-form-input type="datetime-local" v-model="form.from_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="to_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('to_date')">
                            <b-form-input type="datetime-local" v-model="form.to_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="explanation" rules="required" v-slot="{valid, errors}">
                        <ckeditor v-model="form.explanation"/>
                    </ValidationProvider>
                </b-col>
                <b-col cols="8">
                    <ValidationProvider name="file" :rules="form.file_name?'':'required'" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="form.file_name"
                                             :drop-placeholder="$t('drop_file')"
                                             ref="fileInput"
                                             multiple
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="section_ids" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('section_id')">
                            <lined-textarea v-model="form.section_ids" :nowrap="false" :disabled="false"
                                            :styles="{ height: '124px' }" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex">
                <b-button class="mr-2" squared variant="primary" v-b-tooltip.hover :title="$t('show')"
                          @click="showFile()">
                    <i class="ri-file-upload-line" style="font-size: 25px"></i>
                </b-button>
                <b-button variant="primary" @click="save">{{ $t('save').toUpper() }}</b-button>
            </div>
        </ValidationObserver>
    </div>

</template>
<script>

import moment from "moment/moment";
import LmsHomeWorkEntryService from "@/services/LmsHomeWorkEntryService";
import Ckeditor from "@/components/interactive-fields/Ckeditor.vue";
import LinedTextarea from "@/components/elements/LinedTextarea.vue";
import InstructorCourseAutoComplete from "@/components/interactive-fields/InstructorCourseAutoComplete.vue";

export default {
    components: {
        InstructorCourseAutoComplete,
        LinedTextarea,
        Ckeditor
    },
    props: {
        formId:{},
        semesterId: {},
    },
    data() {
        return {
            form:{
                explanation:null,
                file_name:null,
                from_date:null,
                due_date:null,
                instructor_id:null,
                fileData:null,
                section_ids: null,
            },
            instructorValueObject: {},
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData(){
            LmsHomeWorkEntryService.show(this.formId)
                .then(response=>{
                    let data = response.data.data

                    this.instructorValueObject = {
                        value: data.instructor_id,
                        text: data.instructor_name + ' - ' + data.instructor_surname
                    }
                    this.form = {
                        explanation:data.content ? this.decodeHTMLEntities(data.content) : null,
                        section_ids:data.section_ids.join('\n'),
                        instructor_id: data.instructor_id,
                        course_id: data.course_id,
                        semester_id: data.semester_id,
                        from_date: data.from_date,
                        due_date: data.to_date,
                        file: null,
                        file_name: data.file ? data.file.file_name : null,
                        fileData: data.file ? data.file : null,
                    }
                }).catch(err=>{
                this.showErrors(err)
            })
        },
        async  save() {
            const isValid = await this.$refs.formValidate.validate();
            if (isValid){
                const formData = new FormData()
                const dueDate = moment(this.form.due_date).format('YYYY-MM-DD HH:mm:ss')
                const fromDate = moment(this.form.from_date).format('YYYY-MM-DD HH:mm:ss')

                formData.append('explanation',this.form.explanation)
                formData.append('semester_id',this.semesterId)
                formData.append('course_id',this.form.course_id)
                formData.append('instructor_id',this.form.instructor_id)
                formData.append('from_date', fromDate)
                formData.append('due_date', dueDate)

                if (this.form.file) {
                    formData.append('file', this.form.file[0])
                }

                if (this.form.section_ids) {
                    this.form.section_ids
                        .split('\n')
                        .filter(x => x.trim() !== '')
                        .map(x => parseInt(x.trim()))
                        .forEach(id => {
                            formData.append('section_ids[]', id)
                        })
                }
                LmsHomeWorkEntryService.store(formData)
                    .then(response=>{
                        this.$toast.success(response.data.message)
                        this.$emit('updateHomeWorkEntrySuccess',true)
                    }).catch(err=>{
                    this.showErrors(err,this.$refs.formValidate)
                })
            }

        },
        showFile(){
            if(this.form.fileData && this.form.fileData.uuid){
                LmsHomeWorkEntryService.downloadFile(this.form.fileData.uuid)
                    .then(response=>{
                        this._downloadFile(response,this.form.fileData.file_name)
                    }).catch(err=>{
                    this.showErrors(err)
                })
            } else {
                this.$toast.error(this.$t('file_not_found'))
            }

        }
    },

};
</script>
